import { render, staticRenderFns } from "./select-general-language.vue?vue&type=template&id=34540841&scoped=true"
import script from "./select-general-language.vue?vue&type=script&lang=js"
export * from "./select-general-language.vue?vue&type=script&lang=js"
import style0 from "./select-general-language.vue?vue&type=style&index=0&id=34540841&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34540841",
  null
  
)

export default component.exports